import api from '@/lib/axios'

export interface ChatSession {
  id: string
  project_id: string
  title: string | null
  selected_model: string | null
  message_count: number
  created_at: string
  updated_at: string
}

export interface ChatMessage {
  id: string
  session_id: string
  role: 'user' | 'assistant'
  content: string
  cited_document_ids: string[] | null
  tokens_used: number | null
  model_used: string | null
  context_mode: string | null
  created_at: string
}

export const chatApi = {
  createSession: (projectId: string, data: { title?: string; selected_model?: string }) =>
    api.post<ChatSession>(`/projects/${projectId}/chat/sessions`, data).then((r) => r.data),

  listSessions: (projectId: string) =>
    api.get<ChatSession[]>(`/projects/${projectId}/chat/sessions`).then((r) => r.data),

  deleteSession: (projectId: string, sessionId: string) =>
    api.delete(`/projects/${projectId}/chat/sessions/${sessionId}`).then((r) => r.data),

  getMessages: (projectId: string, sessionId: string) =>
    api
      .get<ChatMessage[]>(`/projects/${projectId}/chat/sessions/${sessionId}/messages`)
      .then((r) => r.data),

  // Returns a fetch Response for SSE streaming
  sendMessage: (
    projectId: string,
    sessionId: string,
    content: string,
    selectedModel?: string,
    contextMode?: 'documents' | 'extracted_data' | 'both'
  ) => {
    const token = localStorage.getItem('access_token')
    return fetch(`/api/projects/${projectId}/chat/sessions/${sessionId}/messages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        content,
        ...(selectedModel ? { selected_model: selectedModel } : {}),
        context_mode: contextMode || 'documents',
      }),
    })
  },

  getPlanModels: () =>
    api.get<Array<{
      id: string
      model_name: string
      display_name: string
      is_default: boolean
      chat_credits_per_message: number
      sort_order: number
      is_active: boolean
    }>>('/billing/current-plan/models').then((r) => r.data),

  exportChat: async (projectId: string, sessionId: string, format: 'pdf' | 'markdown' | 'json' = 'pdf') => {
    const token = localStorage.getItem('access_token')
    const res = await fetch(
      `/api/projects/${projectId}/chat/sessions/${sessionId}/export?format=${format}`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    )
    if (!res.ok) throw new Error('Export failed')
    const blob = await res.blob()
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    const ext = format === 'json' ? 'json' : format === 'pdf' ? 'pdf' : 'md'
    a.download = `chat_export.${ext}`
    a.click()
    URL.revokeObjectURL(url)
  },
}
